module.exports = __webpack_public_path__ + "img/home-green-fields.png?e5bcf0d5562537f6b801f5f615cc306d";